import React from "react";
import { Link } from "react-router-dom";

interface PropsType {
  pkg_id: string;
  title: string;
  price?: number;
}
const BookNowCard = (props: PropsType) => {
  return (
    <div className="bg-gray-100 p-8 prose">
      <h2>Booking Available</h2>
      <p>{props.title}</p>
      {/* <div className="flex items-center space-x-2">
        <MdOutlineDateRange />
        <p>12th Feb 2023</p>
      </div> */}
      <div className="">
        {props.price ? (
          <p className="font-semibold">Starting from $2340</p>
        ) : (
          ""
        )}
        <Link
          to={"/booking"}
          state={{
            id: props.pkg_id,
            title: props.title,
          }}
          className="bg-optional px-4 py-2 text-white font-semibold rounded"
        >
          Start Booking Process
        </Link>
      </div>
    </div>
  );
};

export default BookNowCard;
